import { Loader2 } from "lucide-react";
import {
  SPINNER_VARIANTS,
  SPINNER_CONFIG,
  SPINNER_TEXT_STYLES,
} from "./config";
import { RETRIEVING_DATA_SUBTITLE } from "../../../lib/constants";

interface SpinnerProps {
    message?: string;
    isFixed?: boolean;
    showDefaultSubtitle?: boolean; 
}

const Spinner = (props: SpinnerProps) => {
    const { message, isFixed, showDefaultSubtitle = true} = props;

    const subtitleClasses = `${SPINNER_CONFIG.colors.textSecondary} ${SPINNER_TEXT_STYLES.subtitle} text-center max-w-sm px-4 mt-2`;
    const containerClasses = `${SPINNER_VARIANTS.centered} ${isFixed ? SPINNER_VARIANTS.fixed : ''}`;
    const messageClasses = `${SPINNER_CONFIG.colors.text} font-medium ${SPINNER_TEXT_STYLES.subtitle}`;
    const loaderClasses= `${SPINNER_CONFIG.sizes.icon.simple} ${SPINNER_CONFIG.animations.spin} ${SPINNER_CONFIG.colors.primary} ${SPINNER_CONFIG.spacing.iconMargin}`;

    return (
        <div className={containerClasses}>
            <Loader2 className={loaderClasses} />
            {message && (
                <p className={messageClasses}>
                {message}
                </p>
            )}
            {showDefaultSubtitle && (
                <p className={subtitleClasses}>
                {RETRIEVING_DATA_SUBTITLE}
                </p>
            )}
        </div>
    );
};

export default Spinner;